import React from "react";
import Chart from "react-apexcharts";
import { Card, Button } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";

export default function BudgetChart() {

  const categories = [
    "Engineering","Sales","Marketing","Operations",
    "Support","Admin","UI/UX","Devo"
  ];

  const budget = [5000, 10000, 8000, 6000, 5000, 10000, 8000, 10000];
  const spent = [15000, 20000, 16000, 15000, 15000, 20000, 18000, 20000];

  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false }
    },

    colors: ["#f26522", "#0f172a"],

    stroke: {
      curve: "smooth",
      width: 3   // 🔥 thicker line like image
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0,
        opacityFrom: 0.25,   // 🔥 soft fade
        opacityTo: 0.02,
        stops: [0, 100]
      }
    },

    markers: {
      size: 0,
      hover: { size: 5 }
    },

    grid: {
      show: false   // 🔥 remove grid (image style)
    },

    dataLabels: {
      enabled: false
    },

    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: "13px",
          colors: "#374151"
        }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },

    yaxis: {
      labels: {
        style: {
          fontSize: "13px",
          colors: "#6b7280"
        },
        formatter: (val) => `${val / 1000}k`
      }
    },

    tooltip: {
      theme: "light",
      y: {
        formatter: (val) => `$${val.toLocaleString()}`
      }
    },

    legend: {
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "13px",
      markers: {
        width: 10,
        height: 10,
        radius: 12
      }
    }
  };

  const series = [
    { name: "Budget", data: budget },
    { name: "Spent", data: spent }
  ];

  return (
    <>
      <Card className="bc-card w-full w-100">
        <Card.Body>

          {/* HEADER */}
          <div className="bc-header">
            <h6>Department Budget Vs Actual</h6>

            <Button className="bc-btn text-dark">
              <FiDownload />
            </Button>
          </div>

          {/* CHART */}
          <Chart
            options={options}
            series={series}
            type="area"
            height={300}
          />
        </Card.Body>
      </Card>

      <style>{`
        .bc-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          background: #fff;
        }

        .bc-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        .bc-header h6 {
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
        }

        .bc-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: #f3f4f6;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .bc-btn:hover {
          background: #e47b20;
          color:white;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .bc-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }

          .bc-header h6 {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
}